import { faGears, faScaleBalanced } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { QuerySkeleton } from '~/components/atoms/QuerySkeleton';
import { UpdateLegalDocumentForm } from '~/components/forms/LegalDocumentForm';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';
import { useLegalDocumentQuery } from '~/lib/api/modules/LegalDocuments/hooks/useLegalDocumentQuery';

export type IAppUpdateLegalDocumentPageProps = {
  appId: string;
  legalDocumentId: string;
};

export const AppUpdateLegalDocumentPage: React.FC<
  IAppUpdateLegalDocumentPageProps
> = (props) => {
  const { appId, legalDocumentId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const legalDocumentQuery = useLegalDocumentQuery({
    appId,
    legalDocumentId,
  });

  const legalDocument = legalDocumentQuery.data;
  const parentUrl = `/apps/${appId}/settings/legalDocuments`;

  return (
    <>
      <Helmet>
        <title>{t('AppUpdateLegalDocumentPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={`/apps/${appId}/settings`}>
          <FontAwesomeIcon icon={faGears} />
          {t('common.settings')}
        </Breadcrumbs.Action>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faScaleBalanced} />
          {t('AppLegalDocumentsPage.title')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        title={
          <QuerySkeleton
            query={legalDocumentQuery}
            length={{ min: 8, max: 16 }}
          >
            {legalDocument?.title}
          </QuerySkeleton>
        }
        previousUrl={parentUrl}
      />

      <UpdateLegalDocumentForm
        appId={appId}
        legalDocumentId={legalDocumentId}
        onSuccess={() => navigate(parentUrl)}
        cancelUrl={parentUrl}
      />
    </>
  );
};
